import { useDataFlowStore } from '@/stores/dataflowStore';
import { TemplateList } from './TemplateList';
import { TemplateConfig } from './TemplateConfig';

export function TemplatesView() {
  const { selectedTemplateId } = useDataFlowStore();

  return (
    <div className="flex h-full">
      <div className={`${selectedTemplateId ? 'w-1/3' : 'w-full'} border-r border-[var(--border)]`}>
        <TemplateList />
      </div>
      {selectedTemplateId && (
        <div className="w-2/3 bg-[#12161c]">
          <TemplateConfig />
        </div>
      )}
    </div>
  );
}
